module.exports = __webpack_public_path__ + "static/media/CTLA_5-178w.ebd86cfa.webp";